export const ISSUES_BASE_PATH = '/issues'

export const ISSUES_TAB = {
  NON_CONFORMITIES: 'non-conformities',
  OPPORTUNITIES_FOR_IMPROVEMENT: 'opportunities-for-improvement',
} as const

export type IssuesTab = (typeof ISSUES_TAB)[keyof typeof ISSUES_TAB]

export const isIssuesTab = (value: string | undefined): value is IssuesTab =>
  Object.values(ISSUES_TAB).includes(value as IssuesTab)
